import { getApiUrl } from '../config/api';

let catalogCache = null;
let catalogPromise = null;

// Fallback catalog in case API is not available
const FALLBACK_CATALOG = {
  "Concrete": [
    { "name": "Liquid", "unit": "cubic yard (CY)", "unitCode": "CUBIC_YARD" },
    { "name": "Precast", "unit": "cubic yard (CY)", "unitCode": "CUBIC_YARD" },
    { "name": "ReadyMix", "unit": "cubic yard (CY)", "unitCode": "CUBIC_YARD" }
  ],
  "Steel": [
    { "name": "Rebar", "unit": "ton", "unitCode": "TON" },
    { "name": "Beam", "unit": "linear foot (LF)", "unitCode": "LINEAR_FOOT" }
  ],
  "Lumber": [
    { "name": "Plank", "unit": "board foot (BF)", "unitCode": "BOARD_FOOT" },
    { "name": "Timber", "unit": "cubic foot (CF)", "unitCode": "CUBIC_FOOT" }
  ],
  "Brick": [
    { "name": "Mortar", "unit": "bag", "unitCode": "BAG" }
  ],
  "Stone": [
    { "name": "Marble", "unit": "square foot (SF)", "unitCode": "SQUARE_FOOT" }
  ]
};

export const fetchMaterialCatalog = async () => {
  // Return cached catalog if available
  if (catalogCache) {
    console.log('Returning cached catalog');
    return catalogCache;
  }
  
  // Return pending promise if already fetching
  if (catalogPromise) {
    console.log('Returning pending catalog promise');
    return catalogPromise;
  }
  
  // Fetch catalog
  catalogPromise = (async () => {
    try {
      const url = getApiUrl('/api/material/catalog-with-units');
      console.log('Fetching material catalog from:', url);
      const response = await fetch(url);
      console.log('Fetch response:', response.status, response.statusText);
      if (!response.ok) {
        console.warn(`API not available (${response.status}), using fallback catalog`);
        catalogCache = FALLBACK_CATALOG;
        return FALLBACK_CATALOG;
      }
      const data = await response.json();
      console.log('Catalog data received:', data);
      catalogCache = data;
      return data;
    } catch (error) {
      console.error('Error fetching material catalog, using fallback:', error);
      catalogPromise = null;
      catalogCache = FALLBACK_CATALOG;
      return FALLBACK_CATALOG;
    }
  })();
  
  return catalogPromise;
};

export const getCatalogForCategory = (catalog, category) => {
  if (!catalog || !category) return [];
  return catalog[category] || [];
};
const materialCatalog = { fetchMaterialCatalog, getCatalogForCategory };
export default materialCatalog;